
export function scrollTo(id: string) {
  const element = document.getElementById(id);
  if (element) {
    setTimeout(() => {
      window.scrollTo({
        top: element.getBoundingClientRect().top + window.pageYOffset,
        behavior: "smooth",
      });
    }, 100);
  }
}
